import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'

import {
  BuchungsListe,
  type BuchungsFilter,
} from '~/components/interne-buchungen/buchungs-liste.tsx'

const zDatum = z.string().regex(/^\d{4}-\d{2}-\d{2}$/)

/** Die Filter stehen in der Adresse: teilbar, Zurück-Taste funktioniert, Abrechnung kann verlinken. */
const searchSchema = z.object({
  q: z.string().trim().max(200).optional(),
  art: z.enum(['alle', 'einzel', 'sammel', 'abrechnung', 'storno']).optional(),
  laufId: z
    .string()
    .regex(/^[1-9]\d{0,18}$/)
    .optional(),
  herkunft: z.enum(['alle', 'neu', 'migriert']).optional(),
  bcc: z.enum(['alle', 'ja', 'nein']).optional(),
  stornierteAusblenden: z.boolean().optional(),
  sort: z.enum(['datum_ab', 'datum_auf', 'betrag_ab', 'betrag_auf']).optional(),
  von: zDatum.optional(),
  bis: zDatum.optional(),
  seite: z.number().int().min(1).optional(),
})

export const Route = createFileRoute('/interne-buchungen/')({
  component: InterneBuchungenListe,
  validateSearch: searchSchema,
})

function InterneBuchungenListe() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  return (
    <BuchungsListe
      filter={search}
      onFilter={(patch: Partial<BuchungsFilter>) =>
        void navigate({
          search: (alt) => {
            const neu: Record<string, unknown> = { ...alt, ...patch }
            for (const k of Object.keys(neu)) if (neu[k] === undefined) delete neu[k]
            if (neu.seite === 1) delete neu.seite
            return neu
          },
          replace: true,
        })
      }
    />
  )
}
